import { render, staticRenderFns } from "./VSacAppFooter.vue?vue&type=template&id=c748c1fc"
import script from "./VSacAppFooter.vue?vue&type=script&lang=js"
export * from "./VSacAppFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports